<template>
  <div class="lg:mr-8 md:mr-8 lg:mb-0 md:mb-0 mb-8">
    <b-card class="" @change="postData()">
      <p
        class="text-primary hov-underline fsize14 sm-fsize12 text-end font-semibold cursor-pointer"
        @click="clearFilter()"
      >
        Clear Filter
      </p>
      <div class="category">
        <h4 class="fsize24 font-bold">Category</h4>

        <div class="category lg:mt-8 md:mt-6 mt-4">
          <b-form-checkbox
            v-for="(item, index) in categories"
            :key="index"
            v-model="category"
            :id="'checkbox-' + item._id"
            :name="'checkbox-' + item._id"
            :value="item._id"
            :unchecked-value="item._id"
            labelClasses
            class="mb-2 abc h-full"
          >
            <p class="text-646e85 font-medium fsize18">{{ item.name }}</p>
          </b-form-checkbox>
        </div>
      </div>

      <div class="level lg:mt-10 md:mt-10 mt-4">
        <h4 class="fsize24 font-bold">Level</h4>

        <div class="lg:mt-8 md:mt-6 mt-4">
          <b-form-checkbox
            v-for="(item, index) in level"
            :key="index"
            :id="'checkbox2-' + index"
            v-model="getlevel"
            :name="'checkbox-2' + index"
            :value="item"
            :unchecked-value="item"
            class="mb-2"
          >
            <p class="text-646e85 font-medium fsize18">{{ item }}</p>
          </b-form-checkbox>
        </div>
      </div>

      <div class="level lg:mt-10 md:mt-10 mt-4">
        <h4 class="fsize24 font-bold">Price</h4>

        <div class="lg:mt-8 md:mt-6 mt-4">
          <!-- <vue-range-slider
            v-model="priceRange"
            :min="0"
            :step="100"
            :max="5000"
            ref="range"
          ></vue-range-slider> -->

          <b-form-group>
            <div>
              <b-form-radio
                v-model="prices"
                class="custom-control-inline cust-radio-btn mb-2"
                name="some-radios"
                value="0 to 5000"
                ><p class="font-semibold">Show All</p></b-form-radio
              >
            </div>
            <div>
              <b-form-radio
                v-model="prices"
                class="custom-control-inline cust-radio-btn mb-2"
                name="some-radios"
                value="0 to 1000"
                ><p class="font-semibold">0 to 1000</p></b-form-radio
              >
            </div>
            <div>
              <b-form-radio
                v-model="prices"
                class="custom-control-inline cust-radio-btn mb-2"
                name="some-radios"
                value="1000 to 2000"
                ><p class="font-semibold">1000 to 2000</p></b-form-radio
              >
            </div>
            <div>
              <b-form-radio
                v-model="prices"
                class="custom-control-inline cust-radio-btn mb-2"
                name="some-radios"
                value="2000 to 3000"
                ><p class="font-semibold">2000 to 3000</p></b-form-radio
              >
            </div>
            <div>
              <b-form-radio
                v-model="prices"
                class="custom-control-inline cust-radio-btn mb-2"
                name="some-radios"
                value="3000 to 4000"
                ><p class="font-semibold">3000 to 4000</p></b-form-radio
              >
            </div>
            <div>
              <b-form-radio
                v-model="prices"
                class="custom-control-inline cust-radio-btn mb-2"
                name="some-radios"
                value="4000 to 5000"
                ><p class="font-semibold">4000 to 5000</p></b-form-radio
              >
            </div>
          </b-form-group>
        </div>
      </div>

      <div class="level lg:mt-10 md:mt-10 mt-4">
        <h4 class="fsize24 font-bold">Language</h4>

        <div class="lg:mt-8 md:mt-6 mt-4">
          <b-form-checkbox
            v-for="(item, index) in languages"
            :key="index"
            :id="'checkbox1-' + index"
            v-model="lang"
            :name="'checkbox1-' + index"
            :value="item"
            :unchecked-value="item"
            labelClasses
            class="mb-2"
          >
            <p class="text-646e85 font-medium fsize18">{{ item }}</p>
          </b-form-checkbox>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import "vue-range-component/dist/vue-range-slider.css";
import VueRangeSlider from "vue-range-component";

export default {
  components: {
    VueRangeSlider,
  },
  data() {
    return {
      category: [],
      // categories: [
      //   "All",
      //   "UI & UX",
      //   "Animation",
      //   "Game Design",
      //   "Graphic Design",
      //   "Typography",
      //   "Web Development",
      //   "Photography",
      //   " Illustration",
      //   "Programing",
      //   " Graphics",
      //   "Art & Design",
      //   "3D Design",
      // ],
      categories: [],
      priceRange: [0, 5000],
      level: ["Beginners", "Medium", "High"],
      // language: ["English", "Español", "Yorùbá", "বাংলা"],
      courses: [],
      languages: [],
      prices: "",
      lang: [],
      getlevel: [],
      maxVal: 0,
      minVal: 5000,
      slider: "",
    };
  },
  // watch: {
  //   priceRange(range) {
  //     this.minVal = range[0];
  //     this.maxVal = range[1];
  //     // console.log(range);
  //     this.setPrice(() => this.postData(), 1000);
  //   },
  // },
  methods: {
    // setPrice(func, delay = 300) {
    //   let timeout;
    //   clearTimeout(timeout);

    //   timeout = setTimeout(func, delay);
    //   // console.log(timeout);
    // },
    // filterCourseByCategory:function(courses){
    //   return courses.filter(course=> !course.categories.indexOf(this.category))
    // },

    async getCategories() {
      const { data } = await this.$store.dispatch("eLearning/getCategories");
      this.categories = data;
      // console.log("this.$route.query");
      if (this.$route.query.hasOwnProperty("category")) {
        this.selectedCat._id = this.$route.query.category;
      }
      const catId = this.selectedCat._id;
      if (catId) {
        this.category = [this.selectedCat._id];

        this.postData();
      }
    },
    async getCourses() {
      const { data } = await this.$store.dispatch("eLearning/getCourses");

      data.map((items) => {
        // console.log(items.language);
        this.languages.push(items.language);
      });

      const language = [...new Set(this.languages.filter((n) => n))];
      this.languages = language;
      // console.log(this.languages);
    },

    async postData() {
      this.priceRange = this.prices.split(" to ");

      let payload = {};
      if (this.category) Object.assign(payload, { category: this.category });
      if (this.getlevel) Object.assign(payload, { level: this.getlevel });
      if (this.lang) Object.assign(payload, { language: this.lang });
      if (this.priceRange) Object.assign(payload, { price: this.priceRange });
      // console.log(payload);
      const { data } = await this.$store.dispatch(
        "eLearning/getCourses",
        payload
      );
      // console.log(data);
      this.$store.commit("eLearning/getCourses", data);
      // console.log(data);
    },
    async filterData() {
      if (
        this.category.length == 0 ||
        this.getlevel.length == 0 ||
        this.lang.length == 0
      ) {
        const { data } = await this.$store.dispatch("eLearning/getCourses");
        this.$store.commit("eLearning/getCourses", data);
      } else {
        this.postData();
      }
    },
    clearFilter() {
      this.category = [];
      this.getlevel = [];
      this.lang = [];
      this.priceRange = [];
      this.prices = "";
      this.postData();
    },
  },
  mounted() {
    this.getCategories();
    this.getCourses();
  },
  created() {
    // Input not working fix
    VueRangeSlider.methods.handleKeyup = () => console.log();
    VueRangeSlider.methods.handleKeydown = () => console.log();
  },
  computed: {
    ...mapState("eLearning", ["course"]),
    ...mapState("eLearning", ["selectedCat"]),
  },
};
</script>
